import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers} from '../../../../../lib/helpers';
import {AddContentStore} from '../../../x7/content-parts/AddContentStore';
import {syncedVideoEditStoreRenderer} from './synced-video-edit-store-renderer';
import {SyncedVideoEditStore} from './SyncedVideoEditStore';

@observer
export class X9SyncedVideoCreate extends React.Component<{ store: AddContentStore }> {
  readonly store: SyncedVideoEditStore;
  readonly disposers = new Disposers();

  constructor(props: Readonly<{ store: AddContentStore }>) {
    super(props);
    this.store = new SyncedVideoEditStore();
    this.disposers.add(this.store);
    this.setup();
  }

  render() {
    return Array.from(syncedVideoEditStoreRenderer(this.store));
  }

  private setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        (valid) => this.props.store.setValid(valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Contents,
        (contents) => this.props.store.setContents(contents),
        {fireImmediately: true}));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
